<template>
  <div class="v-container">
    <div class="loadding-spin" v-if="loading">
      <Circle4></Circle4>
    </div>
    <div class="card">
      <div class="card-body">
        <div class="title-body">
          <h3>DANH SÁCH GÓI DỊCH VỤ</h3>
          <div class="title-btn">
            <el-button @click="fn_tableShowFormSearch()" icon="el-icon-search"
              >ẩn/hiện tìm kiếm</el-button
            >
            <el-button
              type="primary"
              @click="fn_addGoiDichVu()"
              icon="el-icon-circle-plus-outline"
              >thêm mới gói dịch vụ</el-button
            >
          </div>
        </div>
        <div class="main-body">
          <div class="main-body-search mb-3">
            <b-collapse
              v-bind:visible="mData.tableRules.showFormSearch"
              id="myFormSearch"
              class="b-shadow"
            >
              <b-card style="min-height: auto">
                <el-form
                  ref="myForm"
                  label-position="top"
                  @submit.native.prevent
                  label-width="100px"
                  :model="mData.tableRules.dataSearch.value"
                  :rules="mData.tableRules.dataSearch.valid"
                >
                  <b-row>
                    <b-col md="4">
                      <el-form-item label="Tên gói">
                        <el-input
                          v-model="mData.tableRules.dataSearch.value['ten']"
                          size="medium"
                          placeholder="Nhập tên gói dịch vụ"
                          clearable
                          @input="forceUpdateUI"
                        ></el-input>
                      </el-form-item>
                    </b-col>
                    <b-col md="4">
                      <el-form-item label="Công khai">
                        <el-select
                          v-model="
                            mData.tableRules.dataSearch.value['cong_khai']
                          "
                          placeholder="Lựa chọn trạng thái"
                          size="medium"
                          clearable
                        >
                          <el-option
                            v-for="item in mData.cong_khai"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          >
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </b-col>
                    <b-col md="4">
                      <el-form-item label="Chu kỳ gói">
                        <el-select
                          v-model="
                            mData.tableRules.dataSearch.value['chu_ky_goi.loai']
                          "
                          placeholder="Lựa chọn chu kỳ gói"
                          size="medium"
                          clearable
                        >
                          <el-option
                            v-for="item in mData.chu_ky_goi"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          >
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </b-col>
                  </b-row>
                  <el-form-item class="text-center mb-0">
                    <el-button
                      icon="el-icon-search"
                      type="primary"
                      native-type="submit"
                      v-ladda
                      @click="fn_tableSearch()"
                      >Tìm kiếm</el-button
                    >
                  </el-form-item>
                </el-form>
              </b-card>
            </b-collapse>
          </div>
          <div class="main-body-table">
            <el-table
              stripe
              :data="mData.tableRules.data"
              border
              max-height="540"
              style="width: 100%"
              @sort-change="fn_tableSortChange"
              cell-class-name="cell-table"
            >
              <el-table-column prop="" label="STT" width="50" fixed>
                <template slot-scope="scope">
                  <div class="text-center">
                    {{ mData.tableRules.offset + scope.$index + 1 }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                fixed
                prop="ten"
                label="Tên gói"
                width="150"
                align="center"
              ></el-table-column>
              <el-table-column
                prop="chu_ky_goi_cuoc"
                label="Chu kỳ gói"
                width="120"
                align="center"
              ></el-table-column>
              <el-table-column
                prop=""
                label="Chức năng"
                width="120"
                align="center"
              >
                <el-table-column
                  v-for="item in mData.listChucNang"
                  :key="item.id"
                  :label="item.ten"
                  min-width="120"
                  align="center"
                >
                  <el-table-column
                    prop="ma"
                    label="Mã"
                    min-width="120"
                    align="center"
                  >
                    <span :title="item.ma">{{ item.ma }}</span>
                  </el-table-column>
                  <el-table-column
                    prop="gia_tri"
                    label="Giá trị"
                    width="120"
                    align="center"
                  >
                    <template slot-scope="scope">
                      <div class="text-center">
                        {{ getValueSanPham(item.ma, scope.$index) }}
                      </div>
                    </template>
                  </el-table-column>
                </el-table-column>
              </el-table-column>
              <el-table-column label="Công khai" width="100" align="center">
                <template slot-scope="scope">
                  <i
                    v-if="scope.row.cong_khai"
                    class="fa-solid fa-circle-check"
                  ></i>
                  <i v-else class="fa-solid fa-circle-xmark"></i>
                </template>
              </el-table-column>
              <el-table-column
                prop="thoi_diem_cap_nhat"
                label="Thời điểm cập nhật"
                align="center"
                width="170"
                :sortable="mData.tableRules.allowSorting"
              >
                <template slot-scope="scope">
                  {{ fn_formatDate(scope.row.thoi_diem_cap_nhat) }}
                </template>
              </el-table-column>
              <el-table-column
                label="Thao tác"
                align="center"
                width="150px"
                fixed="right"
              >
                <template slot-scope="scope">
                  <el-button
                    size="mini"
                    plain
                    @click="fn_handle('detail', scope.$index, scope.row)"
                    v-b-popover.hover.left="aLang.c_detail"
                  >
                    <i class="fa fa-eye"></i>
                  </el-button>
                  <el-button
                    size="mini"
                    plain
                    @click="fn_handle('update', scope.$index, scope.row)"
                    v-b-popover.hover.left="aLang.c_update"
                    type="primary"
                  >
                    <i class="far fa-edit"></i>
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
            <div class="mt-2 text-right" v-if="mData.tableRules.allowPaging">
              <el-pagination
                @size-change="fn_tableSizeChange"
                :page-sizes="mData.tableRules.lengthMenu"
                :page-size="mData.tableRules.limit"
                :current-page="mData.tableRules.page"
                @current-change="fn_tableCurentChange"
                @prev-click="fn_tablePrevClick"
                @next-click="fn_tableNextClick"
                background
                layout="total, sizes, prev, pager, next, jumper"
                :total="mData.tableRules.total"
                :pager-count="5"
              ></el-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Circle4 } from "vue-loading-spinner";
import LanguageService from "@/service/LanguageService";
import MethodService from "@/service/MethodService";
import DataForm from "@/dataForm/dataFormGoiDichVu";
import mushroom from "viettoc-api";
export default {
  data() {
    return {
      dong_ho: [],
      aLang: LanguageService.lang,
      loading: true,
      mData: {
        tableRules: MethodService.copyObject(DataForm.tableRules),
        cong_khai: MethodService.copyObject(DataForm.cong_khai),
        chu_ky_goi: MethodService.copyObject(DataForm.chu_ky_goi),
        listChucNang: [],
      },
    };
  },
  components: {
    Circle4,
  },
  methods: {
    async fn_hashUrl() {
      if (this.$route.query.limit) {
        this.mData.tableRules.limit = parseInt(this.$route.query.limit);
      }
      if (this.$route.query.page) {
        this.mData.tableRules.page = parseInt(this.$route.query.page);
      }
      if (this.$route.query.limit && this.$route.query.page) {
        this.mData.tableRules.offset =
          (this.mData.tableRules.page - 1) * this.mData.tableRules.limit;
      }
      if (this.$route.query.sort) {
        this.mData.tableRules.sort = this.$route.query.sort;
        this.mData.tableRules.defaultSort[0] = this.mData.tableRules.sort;
        if (this.mData.tableRules.sort.indexOf("-") != -1) {
          this.mData.tableRules.defaultSort[1] = "descending";
        } else {
          this.mData.tableRules.defaultSort[1] = "ascending";
        }
      }
      if (this.$route.query.filters) {
        this.mData.tableRules.filters = this.$route.query.filters;
        // string to object
        this.mData.tableRules.dataSearch.value = MethodService.stringToObject(
          this.mData.tableRules.filters
        );
      }
      if (this.$route.query.showFormSearch) {
        if (this.$route.query.showFormSearch == "true") {
          this.mData.tableRules.showFormSearch = true;
        } else this.mData.tableRules.showFormSearch = false;
      }
    },
    fn_formatDate(date) {
      return MethodService.formatDate(date, "datetime");
    },
    getValueSanPham(ma, index) {
      if (this.mData.tableRules.data[index].danh_sach_chuc_nang) {
        let count = -1;
        this.mData.tableRules.data[index].danh_sach_chuc_nang.forEach(
          (item, indexItem) => {
            if (item.ma == ma) {
              count = indexItem;
            }
          }
        );
        if (count != -1) {
          return this.mData.tableRules.data[index].danh_sach_chuc_nang[count]
            .gia_tri;
        }

        return "";
      } else {
        return "";
      }
    },
    async fn_getChucNang() {
      const response = await mushroom.pms_chuc_nang.getAllAsync({
        limit: 100,
        sort: "thu_tu",
      });
      if (response.result && response.result.length > 0) {
        response.result.forEach((item) => (item.gia_tri = ""));
      }
      this.mData.listChucNang = response.result;
    },
    fn_tableSizeChange(limit) {
      this.mData.tableRules.limit = limit;
      this.fn_tableChangeOffset(this.mData.tableRules.page);
    },
    fn_tableCurentChange(page) {
      this.fn_tableChangeOffset(page);
    },
    fn_tablePrevClick(page) {
      this.fn_tableChangeOffset(page);
    },
    fn_tableNextClick(page) {
      this.fn_tableChangeOffset(page);
    },
    fn_tableChangeOffset(page) {
      this.mData.tableRules.page = page;
      this.mData.tableRules.offset =
        (this.mData.tableRules.page - 1) * this.mData.tableRules.limit;
      this.fn_initTable();
    },
    async fn_initTable() {
      let dataFilter = {
        filters: this.mData.tableRules.filters,
        fields: this.mData.tableRules.fields,
      };
      if (this.mData.tableRules.allowPaging) {
        dataFilter.limit = this.mData.tableRules.limit;
        dataFilter.offset = this.mData.tableRules.offset;
      }
      if (this.mData.tableRules.allowSorting) {
        dataFilter.sort = this.mData.tableRules.sort;
      }
      if (this.mData.tableRules.showUrl) {
        this.$router
          .replace({
            name: "DanhSachGoiDichVu",
            query: {
              limit: this.mData.tableRules.limit,
              page: this.mData.tableRules.page,
              sort: this.mData.tableRules.sort,
              filters: this.mData.tableRules.filters,
              showFormSearch: this.mData.tableRules.showFormSearch,
            },
          })
          .catch((err) => {});
      }
      try {
        const response = await mushroom.prd_goi_dich_vu.listAsync(dataFilter);
        if (response.result) {
          this.loading = false;
          let resData = await this.fn_changeData(response.result);
          this.mData.tableRules.data = resData;
          this.mData.tableRules.total = response.meta.total;
          this.mData.tableRules.page =
            response.meta.offset / response.meta.limit + 1;
        }
      } catch (e) {
        MethodService.showError(e.code);
        this.loading = false;
      }
    },
    fn_addGoiDichVu() {
      this.$router.push({
        name: "ThemMoiGoiDichVu",
      });
    },
    fn_tableSortChange(column) {
      if (column.order == "ascending") {
        this.mData.tableRules.sort = column.prop;
      } else if (column.order == "descending") {
        this.mData.tableRules.sort = "-" + column.prop;
      } else {
        this.mData.tableRules.sort = "";
      }
      this.fn_initTable();
    },
    formatDate(value) {
      return MethodService.formatDate(value, "datetime");
    },
    async fn_changeData(data) {
      data.forEach(async (ele) => {
        ele.chu_ky_goi_cuoc = ele.chu_ky_goi.gia_tri + " ";
        if (ele.chu_ky_goi.loai) {
          ele.chu_ky_goi_cuoc +=
            ele.chu_ky_goi.loai === "nam"
              ? "năm"
              : ele.chu_ky_goi.loai === "quy"
              ? "quý"
              : "tháng";
        }
      });
      const resChucNang = await mushroom.pms_chuc_nang.getAllAsync({
        fields:
          "id,ma,ten,thu_tu,tuy_bien_hien_thi,kieu_du_lieu,nhom,don_vi,hien_thi",
        sort: "thu_tu",
        limit: 100,
      });
      this.mData.listChucNang.forEach((item) => {
        if (resChucNang.result && resChucNang.result.length > 0) {
          resChucNang.result.forEach((chuc_nang) => {
            if (item.ma === chuc_nang.ma) {
              item.kieu_du_lieu = chuc_nang.kieu_du_lieu;
              item.thu_tu = chuc_nang.thu_tu;
              item.don_vi = chuc_nang.don_vi;
              item.tuy_bien_hien_thi = chuc_nang.tuy_bien_hien_thi || undefined;
            }
          });
        }
        if (item.tuy_bien_hien_thi && item.tuy_bien_hien_thi.length > 0) {
          item.tuy_bien_hien_thi.forEach((x) => {
            if (item.gia_tri === x.gia_tri) item.gia_tri = x.gia_tri_hien_thi;
          });
        }
      });
      return data;
    },

    fn_handle(type, scope, row) {
      if (type == "detail") {
        this.$router.push({
          name: "ChiTietGoiDichVu",
          params: { id: row.id },
        });
      }
      if (type == "update") {
        this.$router.push({
          name: "CapNhatGoiDichVu",
          params: { id: row.id },
        });
      }
    },

    // tìm kiếm
    fn_tableShowFormSearch() {
      this.mData.tableRules.showFormSearch =
        !this.mData.tableRules.showFormSearch;

      this.$router.replace({
        name: "DanhSachGoiDichVu",
        query: {
          limit: this.mData.tableRules.limit,
          page: this.mData.tableRules.page,
          sort: this.mData.tableRules.sort,
          filters: this.mData.tableRules.filters,
          showFormSearch: this.mData.tableRules.showFormSearch,
        },
      });
      this.fn_initTable(this.mData.tableRules.filters);
    },
    fn_tableSearch() {
      if (this.mData.tableRules.dataSearch.value["ten"]) {
        this.mData.tableRules.dataSearch.value["ten"] =
          this.mData.tableRules.dataSearch.value["ten"].trim();
      }
      this.$refs["myForm"].validate(async (valid) => {
        if (valid) {
          this.loading = true;
          this.mData.tableRules.filters = MethodService.filterTable(
            JSON.stringify(this.mData.tableRules.dataSearch)
          );
          this.mData.tableRules.offset = 0;
          this.fn_initTable();
          MethodService.stopLadda();
        } else {
          MethodService.stopLadda();
          return false;
        }
      });
    },

    forceUpdateUI() {
      this.$forceUpdate();
    },
  },
  //run after render view
  async created() {
    await this.fn_hashUrl();
    await this.fn_getChucNang();
    await this.fn_initTable();
  },
};
</script>
<style scoped lang="scss">
.card {
  min-height: 88vh;
}
.card-header {
  background-color: #fafafa;
  border: 1px solid rgba(26, 54, 126, 0.125);
  border-bottom: none;
  text-align: center;
}
.title-body {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: column;
}
.title-btn {
  margin-top: 10px;
}
.image-zone {
  border: 1px dashed #409eff;
  border-radius: 5px;
  padding: 5px;
  height: 210px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.cell-table {
  .cell {
    line-height: 100%;
  }
  i.fa-circle-check,
  i.fa-circle-xmark {
    font-size: 16px;
  }
  i.fa-circle-check {
    color: #67c23a;
  }
  i.fa-circle-xmark {
    color: #f56c6c;
  }
}

@media (min-width: 960px) {
  .title-body {
    flex-direction: row;
  }
}
</style>
